export const handleSuccessfulSubmission = async (callback: (...arguments_: any[]) => void, timeout = 800) => {
    await new Promise((resolve) => setTimeout(resolve, timeout));
    callback();
};
